<app-progress-spinner
  fxFlex
  fxLayoutAlign="center center"
  *ngIf="!technicalDatasheetsHaveBeenLoaded; else loadedTechnicalDatasheets"
  [text]="'GENERAL.LOADING.LOADING' | bmsTranslate"
></app-progress-spinner>

<ng-template #loadedTechnicalDatasheets>
  <app-technical-datasheet-list
    *ngIf="hasTechnicalDatasheets()"
    [listOfTechnicalDatasheets]="listOfTechnicalDatasheets"
    [selectedTechnicalDatasheet]="selectedTechnicalDatasheet"
    (selectedTechnicalDatasheetChange)="onSelectedTechnicalDatasheetChange($event)"
    (virtualScrollerEnd)="onVirtualScrollerEnd()"
  ></app-technical-datasheet-list>

  <vdw-nodata-overlay
    fxLayoutAlign="start center"
    fxFlex
    *ngIf="!hasTechnicalDatasheets()"
    titleParam="TECHNICAL_DATASHEETS.DATASHEET"
    [filterDescriptionParam]="{paramKeyCreate: 'TECHNICAL_DATASHEETS.DATASHEET'}"
  >
  </vdw-nodata-overlay>
</ng-template>
